import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Card,
    CardContent,
    Button,
    Typography,
    TextField,
    Select,
    MenuItem,
} from "@material-ui/core";
import MapContainer from "../MapContainer";
import { StyledHeader } from "../../styles";
import { Link } from "react-router-dom";
import { selectReport } from "./selectors";
import { getReport, setReport, getJobPackReports } from "./actions";
import { gridStyle, cellStyle } from "../gridHelper";
import PrintIcon from "@material-ui/icons/Print";
import data from "./dataDaily.json";
import dataWeekely from "./dataWeekely.json";

import { noImg } from "vrcore-dashboard/dist/utilities";
import ReactToPrint from "react-to-print";
import styled from "styled-components";
import "../reports.css";

import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
const ActionButton = styled(Button)`
    @media print {
        visibility: hidden;
    }
`;
let checkedit = "";
class DWIReport extends Component {
    constructor(props) {
        super(props);
        let path = props.location.pathname.split("/");
        checkedit = path[1];
        this.state = {
            imageModal: false,
            selectedImg: false,
            report: false,
            editing:
                path[1] === "report-view"
                    ? false
                    : path[1] === "report-view-standalone"
                    ? false
                    : true,
            title: document.title,
            reportType: path[4].replace(/-/g, "_"),
            checks: data,
            list: dataWeekely,
        };

        if (path[2] === "reports") {
            props.getReport(
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/_/g, " ").replace(/\./g, ":")
            );
        } else {
            props.getJobPackReports(
                props.match.params.uid,
                path[2].replace(/-/g, "_"),
                path[3],
                path[4].replace(/-/g, "_"),
                path[5].replace(/-/g, "_"),
                path[7].replace(/-/g, "_"),
                props.match.params.report_id
                    .replace(/_/g, " ")
                    .replace(/\./g, ":")
            );
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.report !== prevProps.report) {
            this.setState({ report: this.props.report });
        }
    }
    renderInspection = (key, value = false) => {
        let col = "green";
        value === "Amber"
            ? (col = "green")
            : value === "U"
            ? (col = "orange")
            : value === "I"
            ? (col = "red")
            : (col = "grey");
        if (this.state.editing) {
            return (
                <Select
                    value={
                        this.state.report[key] === undefined
                            ? false
                            : this.state.report[key]
                    }
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                    style={{ minWidth: "100%", background: col }}
                >
                    <MenuItem value={"A"} style={{ background: "green" }}>
                        A
                    </MenuItem>
                    <MenuItem value={"U"} style={{ background: "orange" }}>
                        U
                    </MenuItem>
                    <MenuItem value={"I"} style={{ background: "red" }}>
                        I
                    </MenuItem>
                    <MenuItem value={"N/R"} style={{ background: "grey" }}>
                        N/R
                    </MenuItem>
                </Select>
            );
        } else {
            return <div style={this.statusStyle(value)}>{value}</div>;
        }
    };
    renderText = (key, value) => {
        if (this.state.editing) {
            return (
                <TextField
                    value={this.state.report[key]}
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                />
            );
        } else {
            return value;
        }
    };
    renderText1 = (key) => {
        if (this.state.editing) {
            return (
                <TextField
                    value={key}
                    // onChange={event => {
                    //     let report = {
                    //         ...this.state.report,
                    //         [key]: event.target.value
                    //     };
                    //     this.setState({ report });
                    // }}
                />
            );
        } else {
            return key;
        }
    };
    renderDropDown = (key, value, opts) => {
        if (this.state.editing) {
            return (
                <Select
                    style={{ width: "100%" }}
                    value={
                        this.state.report[key] === ""
                            ? "N/A"
                            : this.state.report[key]
                    }
                    onChange={(event) => {
                        let report = {
                            ...this.state.report,
                            [key]: event.target.value,
                        };
                        this.setState({ report });
                    }}
                >
                    <MenuItem value="N/A">N/A</MenuItem>
                    {opts.map((option) => {
                        return (
                            <MenuItem value={option} key={option}>
                                {option}
                            </MenuItem>
                        );
                    })}
                </Select>
            );
        } else {
            return value === "" ? "N/A " : value;
        }
    };
    statusStyle = (value) => {
        let color = "black";
        let background = "white";

        if (value === "Amber") {
            background = "orange";
        } else if (value === "Green") {
            background = "green";
        } else if (value === "Red") {
            background = "red";
        } else {
            background = "grey";
        }

        return {
            minWidth: "100%",
            minHeight: "100%",
            color,
            background,
            textAlign: "center",
        };
    };
    renderSignatures(attachedSignatures) {
        let photoRow = 2;
        let photoCell = 1;
        return attachedSignatures.map((sig, i) => {
            let photoInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell,
                            photoRow,
                            photoCell,
                            true
                        )}
                    >
                        {sig.signature_name}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell + 1,
                            photoRow,
                            photoCell + 1,
                            true
                        )}
                    >
                        {sig.signature_timestamp}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow + 1,
                            photoCell,
                            photoRow + 1,
                            photoCell + 2
                        )}
                    >
                        <img
                            src={sig.signature_url}
                            alt="Site "
                            onClick={() => {
                                this.setState({
                                    selectedPhoto: sig,
                                    imageModal: true,
                                });
                            }}
                            style={{
                                width: 100,
                                height: 100,
                                margin: "auto",
                                cursor: "pointer",
                            }}
                        />
                    </div>
                </React.Fragment>
            );
            photoCell += 2;
            if (photoCell === 9) {
                photoRow += 2;
                photoCell = 1;
            }
            return photoInfo;
        });
    }
    renderPhotos(attachedPhotos) {
        let photoRow = 2;
        let photoCell = 1;
        return attachedPhotos.map((photo, i) => {
            let photoInfo = (
                <React.Fragment key={i}>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell,
                            photoRow,
                            photoCell,
                            true
                        )}
                    >
                        {photo.photo_name}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow,
                            photoCell + 1,
                            photoRow,
                            photoCell + 1,
                            true
                        )}
                    >
                        {photo.photo_timestamp}
                    </div>
                    <div
                        style={cellStyle(
                            photoRow + 1,
                            photoCell,
                            photoRow + 1,
                            photoCell + 2
                        )}
                    >
                        <img
                            src={photo.photo_url}
                            alt="Site "
                            onClick={() => {
                                this.setState({
                                    selectedPhoto: photo,
                                    imageModal: true,
                                });
                            }}
                            style={{
                                width: 300,
                                height: 300,
                                margin: "auto",
                                cursor: "pointer",
                            }}
                        />
                    </div>
                </React.Fragment>
            );
            photoCell += 2;
            if (photoCell === 9) {
                photoRow += 2;
                photoCell = 1;
            }
            return photoInfo;
        });
    }
    render() {
        //let report = this.props.report === false ? false : this.props.report;
        //  let dp = this.renderDropDown;

        let gstyle = gridStyle;
        let cstyle = cellStyle;

        const { checks, report, selectedImg, list } = this.state;
        return (
            <Card>
                <StyledHeader style={{ background: "#0188cc" }}>
                    <Typography variant="h5" style={{ color: "white" }}>
                        Daily/Weekly Tractor (Agricultural) Operator Inspection
                        Sheet
                        <ReactToPrint
                            onBeforePrint={() => {
                                setTimeout(undefined, 2000);
                                document.title =
                                    "Examination Report- " +
                                    this.props.match.params.report_id
                                        .replace(/_/g, " ")
                                        .replace(/\./g, ":");
                            }}
                            onAfterPrint={() => {
                                document.title = this.state.title;
                            }}
                            trigger={() => (
                                <PrintIcon
                                    style={{
                                        float: "right",
                                        fontSize: "36px",
                                        marginRight: "30px",
                                        cursor: "pointer",
                                    }}
                                />
                            )}
                            content={() => this.componentRef}
                        />
                    </Typography>
                </StyledHeader>
                <CardContent>
                    {report && (
                        <>
                            <div ref={(el) => (this.componentRef = el)}>
                                {this.props.header && <this.props.header />}
                                <div
                                    className="imgDiv"
                                    style={{
                                        float: "left",
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <Typography variant="h5">
                                        Daily/Weekly Tractor (Agricultural)
                                        Operator Inspection Sheet
                                    </Typography>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div
                                        style={{ width: "50%", float: "left" }}
                                    >
                                        <div style={gstyle(5, 13)}>
                                            <div
                                                style={cstyle(
                                                    1,
                                                    1,
                                                    1,
                                                    13,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Report Details</b>
                                            </div>
                                            <div style={cstyle(2, 1, 2, 13)}>
                                                <b>Name: </b>&nbsp;{" "}
                                                {report.user_name
                                                    ? report.user_name
                                                    : "N/A"}
                                            </div>
                                            <div style={cstyle(4, 1, 4, 13)}>
                                                <b>Date: </b>&nbsp;{" "}
                                                {report.timestamp
                                                    ? report.timestamp
                                                    : "N/A"}
                                            </div>
                                            <div style={cstyle(5, 1, 5, 13)}>
                                                <b>Project Name: </b>&nbsp;{" "}
                                                {report.project_name}
                                            </div>
                                            <div style={cstyle(6, 1, 6, 13)}>
                                                <b>
                                                    Plant Hour/Reading Meter:{" "}
                                                </b>
                                                &nbsp;{" "}
                                                {
                                                    report.plant_hour_reading_meter
                                                }
                                            </div>
                                            <div style={cstyle(7, 1, 7, 13)}>
                                                <b>Plant ID/Serial No.: </b>
                                                &nbsp; {report.plant_id_serial}
                                            </div>
                                            <div style={cstyle(8, 1, 8, 13)}>
                                                <b>Week Commencing: </b>&nbsp;{" "}
                                                {report.week_commencing}
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            float: "left",
                                            marginLeft: "5%",
                                            width: "45%",
                                            zIndex: "500",
                                            // height:
                                            //     this.infoDiv === undefined
                                            //         ? 0
                                            //         : this.infoDiv
                                            //             .offsetHeight - 10
                                        }}
                                    >
                                        <MapContainer
                                            lat={+report.location_lat}
                                            long={+report.location_lon}
                                        />
                                    </div>
                                </div>
                                <div style={{ width: "100%", clear: "both" }}>
                                    <div
                                        style={{ width: "100%", float: "left" }}
                                    >
                                        <div style={gstyle(5, 13)}>
                                            <div
                                                style={cstyle(
                                                    1,
                                                    1,
                                                    1,
                                                    13,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Inspection Type</b>
                                            </div>
                                            <div style={cstyle(2, 1, 2, 13)}>
                                                <b>Inspection Type: </b>&nbsp;{" "}
                                                {report.inspection_type
                                                    ? report.inspection_type
                                                    : "N/A"}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div style={{ width: "100%", clear: "both" }}>
                                    <div style={gstyle(4, 4)}>
                                        <div
                                            style={cstyle(
                                                1,
                                                1,
                                                1,
                                                4,
                                                false,
                                                true
                                            )}
                                        >
                                            <b>Rating Code Table</b>
                                        </div>
                                        <div style={cstyle(2, 1, 2, 1)}>
                                            <b>Ref No.:</b>
                                        </div>
                                        <div style={cstyle(2, 2, 2, 2)}>
                                            <b>Colour Code:</b>
                                        </div>
                                        <div style={cstyle(2, 3, 2, 4)}>
                                            <b>Definition:</b>
                                        </div>
                                        <div style={cstyle(3, 1, 3, 1)}>1</div>
                                        <div style={cstyle(3, 2, 3, 2)}>
                                            <div
                                                style={this.statusStyle(
                                                    "Green"
                                                )}
                                            >
                                                Green
                                            </div>
                                        </div>
                                        <div style={cstyle(3, 3, 3, 4)}>
                                            No Defect
                                        </div>
                                        <div style={cstyle(4, 1, 4, 1)}>2</div>
                                        <div style={cstyle(4, 2, 4, 2)}>
                                            <div
                                                style={this.statusStyle(
                                                    "Amber"
                                                )}
                                            >
                                                Amber
                                            </div>
                                        </div>
                                        <div style={cstyle(4, 3, 4, 4)}>
                                            Temporary Fix Required
                                        </div>
                                        <div style={cstyle(5, 1, 5, 1)}>3</div>
                                        <div style={cstyle(5, 2, 5, 2)}>
                                            <div
                                                style={this.statusStyle("Red")}
                                            >
                                                Red
                                            </div>
                                        </div>
                                        <div style={cstyle(5, 3, 5, 4)}>
                                            Unroadworthy
                                        </div>
                                        <div style={cstyle(6, 1, 6, 1)}>4</div>
                                        <div style={cstyle(6, 2, 6, 2)}>
                                            <div
                                                style={this.statusStyle("N/A")}
                                            >
                                                N/A
                                            </div>
                                        </div>
                                        <div style={cstyle(6, 3, 6, 4)}>
                                            N/A
                                        </div>
                                    </div>
                                </div>
                                {report.inspection_type === "Daily"
                                    ? Object.keys(checks).map((e) => {
                                          let checkRowCount = 2;

                                          return (
                                              <div
                                                  style={{
                                                      width: "100%",
                                                      clear: "both",
                                                  }}
                                              >
                                                  <div
                                                      style={gstyle(
                                                          checks[e].length + 3,
                                                          5,
                                                          null
                                                      )}
                                                  >
                                                      <div
                                                          style={cstyle(
                                                              2,
                                                              1,
                                                              2,
                                                              1,
                                                              false
                                                          )}
                                                      >
                                                          <b>Ref No.</b>
                                                      </div>
                                                      <div
                                                          style={cstyle(
                                                              2,
                                                              2,
                                                              2,
                                                              2,
                                                              false
                                                          )}
                                                      >
                                                          <b>Checks</b>
                                                      </div>
                                                      <div
                                                          style={cstyle(
                                                              2,
                                                              3,
                                                              2,
                                                              3,
                                                              false
                                                          )}
                                                      >
                                                          <b>Status</b>
                                                      </div>
                                                      <div
                                                          style={cstyle(
                                                              2,
                                                              4,
                                                              2,
                                                              4,
                                                              false
                                                          )}
                                                      >
                                                          <b>Comments</b>
                                                      </div>

                                                      {checks[e].map((f) => {
                                                          checkRowCount++;

                                                          return (
                                                              <React.Fragment
                                                                  key={
                                                                      checkRowCount
                                                                  }
                                                              >
                                                                  <div
                                                                      style={cellStyle(
                                                                          checkRowCount,
                                                                          1,
                                                                          checkRowCount,
                                                                          1
                                                                      )}
                                                                  >
                                                                      {this.renderText1(
                                                                          f.refno
                                                                      )}
                                                                  </div>
                                                                  <div
                                                                      style={cellStyle(
                                                                          checkRowCount,
                                                                          2,
                                                                          checkRowCount,
                                                                          2
                                                                      )}
                                                                  >
                                                                      {
                                                                          f.question
                                                                      }
                                                                  </div>
                                                                  <div
                                                                      style={cellStyle(
                                                                          checkRowCount,
                                                                          3,
                                                                          checkRowCount,
                                                                          3
                                                                      )}
                                                                  >
                                                                      {this.renderInspection(
                                                                          f.inspected,
                                                                          report[
                                                                              f
                                                                                  .inspected
                                                                          ],
                                                                          [
                                                                              "Yes",
                                                                              "No",
                                                                          ]
                                                                      )}
                                                                  </div>
                                                                  <div
                                                                      style={cellStyle(
                                                                          checkRowCount,
                                                                          4,
                                                                          checkRowCount,
                                                                          4
                                                                      )}
                                                                  >
                                                                      {
                                                                          report[
                                                                              f
                                                                                  .comments
                                                                          ]
                                                                      }
                                                                  </div>
                                                              </React.Fragment>
                                                          );
                                                      })}
                                                  </div>
                                              </div>
                                          );
                                      })
                                    : Object.keys(list).map((e) => {
                                          let checkRowCount = 2;

                                          return (
                                              <div
                                                  style={{
                                                      width: "100%",
                                                      clear: "both",
                                                  }}
                                              >
                                                  <div
                                                      style={gstyle(
                                                          checks[e].length + 3,
                                                          5,
                                                          null
                                                      )}
                                                  >
                                                      <div
                                                          style={cstyle(
                                                              2,
                                                              1,
                                                              2,
                                                              1,
                                                              false
                                                          )}
                                                      >
                                                          <b>Ref No.</b>
                                                      </div>
                                                      <div
                                                          style={cstyle(
                                                              2,
                                                              2,
                                                              2,
                                                              2,
                                                              false
                                                          )}
                                                      >
                                                          <b>Checks</b>
                                                      </div>
                                                      <div
                                                          style={cstyle(
                                                              2,
                                                              3,
                                                              2,
                                                              3,
                                                              false
                                                          )}
                                                      >
                                                          <b>Status</b>
                                                      </div>
                                                      <div
                                                          style={cstyle(
                                                              2,
                                                              4,
                                                              2,
                                                              4,
                                                              false
                                                          )}
                                                      >
                                                          <b>Comments</b>
                                                      </div>

                                                      {list[e].map((g) => {
                                                          checkRowCount++;

                                                          return (
                                                              <React.Fragment
                                                                  key={
                                                                      checkRowCount
                                                                  }
                                                              >
                                                                  <div
                                                                      style={cellStyle(
                                                                          checkRowCount,
                                                                          1,
                                                                          checkRowCount,
                                                                          1
                                                                      )}
                                                                  >
                                                                      {this.renderText1(
                                                                          g.refno
                                                                      )}
                                                                  </div>
                                                                  <div
                                                                      style={cellStyle(
                                                                          checkRowCount,
                                                                          2,
                                                                          checkRowCount,
                                                                          2
                                                                      )}
                                                                  >
                                                                      {
                                                                          g.question
                                                                      }
                                                                  </div>
                                                                  <div
                                                                      style={cellStyle(
                                                                          checkRowCount,
                                                                          3,
                                                                          checkRowCount,
                                                                          3
                                                                      )}
                                                                  >
                                                                      {this.renderInspection(
                                                                          g.inspected,
                                                                          report[
                                                                              g
                                                                                  .inspected
                                                                          ],
                                                                          [
                                                                              "Yes",
                                                                              "No",
                                                                          ]
                                                                      )}
                                                                  </div>
                                                                  <div
                                                                      style={cellStyle(
                                                                          checkRowCount,
                                                                          4,
                                                                          checkRowCount,
                                                                          4
                                                                      )}
                                                                  >
                                                                      {
                                                                          report[
                                                                              g
                                                                                  .comments
                                                                          ]
                                                                      }
                                                                  </div>
                                                              </React.Fragment>
                                                          );
                                                      })}
                                                  </div>
                                              </div>
                                          );
                                      })}
                                <div style={{ width: "100%", clear: "both" }}>
                                    <div
                                        style={{ width: "100%", float: "left" }}
                                    >
                                        <div style={gstyle(5, 13)}>
                                            <div
                                                style={cstyle(
                                                    1,
                                                    1,
                                                    1,
                                                    13,
                                                    false,
                                                    true
                                                )}
                                            >
                                                <b>Defects Report</b>
                                            </div>
                                            <div style={cstyle(2, 1, 2, 13)}>
                                                <b>Report To: </b>&nbsp;{" "}
                                                {report.defect_report_to
                                                    ? report.defect_report_to
                                                    : "N/A"}
                                            </div>
                                            <div style={cstyle(3, 1, 3, 13)}>
                                                <b>Actions Taken: </b>&nbsp;{" "}
                                                {report.defect_actions_taken
                                                    ? report.defect_actions_taken
                                                    : "N/A"}
                                            </div>
                                            <div style={cstyle(4, 1, 4, 13)}>
                                                <b>Operator’s Comments: </b>
                                                &nbsp;{" "}
                                                {report.operator_comments
                                                    ? report.operator_comments
                                                    : "N/A"}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={gstyle(5, 10)}>
                                    <div
                                        style={cstyle(1, 1, 1, 1, false, true)}
                                    >
                                        <b>Attached Signatures</b>
                                    </div>
                                    {report.attached_signatures &&
                                        this.renderSignatures(
                                            report.attached_signatures
                                        )}
                                </div>

                                <div style={gstyle(5, 10)}>
                                    <div
                                        style={cstyle(1, 1, 1, 1, false, true)}
                                    >
                                        <b>Attached Photos</b>
                                    </div>
                                    {report.attached_photos &&
                                        this.renderPhotos(
                                            report.attached_photos
                                        )}
                                </div>
                            </div>
                        </>
                    )}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        {this.state.editing &&
                            checkedit === "report-edit-jobpack" && (
                                <Link
                                    to={this.props.location.pathname.replace(
                                        "report-edit-jobpack",
                                        "report-view"
                                    )}
                                >
                                    <div>
                                        <ActionButton
                                            style={{ marginRight: 10 }}
                                            onClick={() => {
                                                this.props.setReport(
                                                    this.state.report,
                                                    this.props.location.pathname
                                                );
                                            }}
                                            variant="contained"
                                            color="primary"
                                        >
                                            Submit
                                        </ActionButton>
                                        <ActionButton
                                            color="secondary"
                                            variant="contained"
                                        >
                                            Cancel
                                        </ActionButton>
                                    </div>
                                </Link>
                            )}

                        {!this.state.editing && checkedit === "report-view" && (
                            <Link
                                to={this.props.location.pathname.replace(
                                    "report-view",
                                    "report-edit-jobpack"
                                )}
                            >
                                {/* <ActionButton
                                                variant="contained"
                                                color="primary"
                                            >
                                                Edit
                                        </ActionButton> */}
                            </Link>
                        )}
                    </div>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        {this.state.editing && checkedit === "report-edit" && (
                            <Link
                                to={this.props.location.pathname.replace(
                                    "report-edit",
                                    "report-view-standalone"
                                )}
                            >
                                <div>
                                    <ActionButton
                                        style={{ marginRight: 10 }}
                                        onClick={() => {
                                            this.props.setReport(
                                                this.state.report,
                                                this.props.location.pathname
                                            );
                                        }}
                                        variant="contained"
                                        color="primary"
                                    >
                                        Submit
                                    </ActionButton>
                                    <ActionButton
                                        color="secondary"
                                        variant="contained"
                                    >
                                        Cancel
                                    </ActionButton>
                                </div>
                            </Link>
                        )}

                        {!this.state.editing &&
                            checkedit === "report-view-standalone" && (
                                <Link
                                    to={this.props.location.pathname.replace(
                                        "report-view-standalone",
                                        "report-edit"
                                    )}
                                >
                                    {/* <ActionButton
                                                variant="contained"
                                                color="primary"
                                            >
                                                Edit
                                        </ActionButton> */}
                                </Link>
                            )}
                    </div>

                    {report && (
                        <Modal isOpen={this.state.imageModal}>
                            <ModalHeader>Additional Notes Image</ModalHeader>
                            <ModalBody style={{ margin: "auto" }}>
                                <img
                                    src={
                                        selectedImg === undefined ||
                                        selectedImg === null ||
                                        selectedImg === ""
                                            ? noImg
                                            : selectedImg
                                    }
                                    alt="Site"
                                    style={{ width: "350px", height: "350px" }}
                                />
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        this.setState({
                                            selectedImg: false,
                                            imageModal: false,
                                        });
                                    }}
                                >
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>
                    )}
                </CardContent>
            </Card>
        );
    }
}
export default connect(
    (store) => {
        return { report: selectReport(store) };
    },
    { getReport, setReport, getJobPackReports }
)(DWIReport);
